import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { mDom } from '../../../core/js/utils/renderUtils';
import { CATEGORY_REFINEMENT_NAMES } from '@core/js/constants';

import {
    requestFacetedItems,
    setCustomPriceRange,
    clearCustomPriceRange
} from '../actions/facetActions';

import {
    getCurrentCategory
} from '../utils/utils';

import { submitCustomPriceForm } from '../sagas/categoryFacetSagas';

import template from 'facets/custom-price-range.j2';

/**
 * Update the disabled / active state of the custom price range buttons
 * @param {object} store - The store
 * @returns {undefined}
 */
function updateFormUI(store) {
    const state = store.getState();
    const applyButton = $(this.scopedSelector('.js-apply-button'));
    const clearButton = $(this.scopedSelector('.js-custom-price__button--clear'));
    const nav = _.get(state, 'category.facetOptions.nav');
    const priceFacet = _.find(nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });
    const priceRangeState = _.get(priceFacet, 'customPriceRange', {});
    const minPrice = _.get(priceRangeState, 'min', '');
    const maxPrice = _.get(priceRangeState, 'max', '');
    const hasBeenEdited = _.get(priceRangeState, 'hasBeenEdited', false);
    const customPriceInputsAreEmpty = _.trim(minPrice) === '' && _.trim(maxPrice) === '';
    const customPriceRangeIsSelected = _.get(priceRangeState, 'isSelected');

    if (!hasBeenEdited || customPriceInputsAreEmpty) {
        applyButton.attr('disabled', 'disabled');
        if(!customPriceRangeIsSelected) {
            clearButton.attr('disabled', 'disabled');
        } else {
            clearButton.removeAttr('disabled');
        }
    } else {
        applyButton.removeAttr('disabled');
        clearButton.removeAttr('disabled');
    }
}

function attachEvents(store) {
    const _this = this;

    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-price-range-form'), (e) => {
        e.preventDefault();
        this.attachLoader(store, { location: this.getLoaderLocationForDeviceSize() });
        store.runSaga(submitCustomPriceForm, store, e, this);
        return false;
    });

    $(document).on(this.scopedEvent('input'),
    `${this.scopedSelector('.js-min-price-range')}, ${this.scopedSelector('.js-max-price-range')}`, (e) => {
        const state = store.getState();
        const nav = _.get(state, 'category.facetOptions.nav');
        const priceFacet = _.find(nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });
        const inputField = $(e.target);
        const inputValue = inputField.val();
        const newValue = inputValue.replace(/[^0-9]/g, '');
        const updateKey = (_.get(e, 'target.name', '') === 'minPrice') ? 'min' : 'max';
        const currentStateValue = _.get(priceFacet, `customPriceRange.${updateKey}`);

        // if user entered non numeric value, and the cleaned value is equal to the existing state
        if (newValue === currentStateValue && newValue !== inputValue) {
            inputField.val(newValue);
            return false;
        }

        store.dispatch(setCustomPriceRange(updateKey, newValue));
        _this.updateFormUI(store);
        return true;
    });

    $(document).on(this.scopedEvent('click'), `${this.scopedSelector('.js-custom-price__button--clear')}`, (e) => {
        e.preventDefault();
        store.dispatch(clearCustomPriceRange());

        const state = store.getState();
        const nav = _.get(state, 'category.facetOptions.nav');
        const priceFacet = _.find(nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });
        const qs = _.get(priceFacet, 'customPriceRange.queryString');
        const customPriceRangeIsSelected = _.get(priceFacet, 'customPriceRange.isSelected');

        if(customPriceRangeIsSelected) {
            this.attachLoader(store, { location: this.getLoaderLocationForDeviceSize() });
            store.dispatch(requestFacetedItems(getCurrentCategory(), '', '', false, qs));
        } else {
            this.render(store, this, {});
        }
    });
}

export function generateDictionary(state, dictionary, config) {
    const nav = _.get(state, 'category.facetOptions.nav');
    const navItem = _.find(nav, { 'name': CATEGORY_REFINEMENT_NAMES.PRICE });
    const dict = {
        navItem: navItem
    };

    return Object.assign({}, state, dictionary, dict);
}

export function firstRender() {
    this.updateFormUI(this.store);
}

function getLoaderLocationForDeviceSize() {
    const state = this.store.getState();
    const isSmallish = _.get(state, 'core.deviceCharacteristics.is_small', false) ||
                                _.get(state, 'core.deviceCharacteristics.is_extra_small', false);

    return isSmallish ? this.parent.templateLocation : '.js-category-grid';
}

export function init(store, overrides = {}) {
    const config = {
        name: 'customPriceRangeComponent',
        attachEvents: attachEvents,
        templateLocation: '.dom-custom-price-range',
        firstRender: firstRender,
        template: template,
        getLoaderLocationForDeviceSize: getLoaderLocationForDeviceSize,
        generateDictionary: generateDictionary,
        watch: ['category.catalogRequestUrl'],
        updateFormUI: updateFormUI,
        renderType: mDom
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
